import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Envio de Mensajes
                </h2>
                <p>
                    Envia mensajes a Alumnos
                </p>
            </div>
        </div>
    );
};

export default Header;